var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-xs-12" },
    [
      _c(
        "transition",
        {
          on: {
            "before-enter": _vm.debriefBeforeEnter,
            enter: _vm.debriefEnter,
            "after-enter": _vm.debriefAfterEnter,
          },
        },
        [
          _vm.questionAnswered && _vm.debrief
            ? _c("div", { staticClass: "trivia-debrief" }, [
                _c(
                  "div",
                  { staticClass: "card row", staticStyle: { display: "flex" } },
                  [
                    _c("div", { staticClass: "col-xs-8" }, [
                      _c("p", {
                        staticClass: "trivia-debrief-text",
                        domProps: { innerHTML: _vm._s(_vm.debrief.text) },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "trivia-debrief-link" },
                        [
                          _vm.debrief.link
                            ? [
                                _c("resource", { staticClass: "svg-icon" }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.debrief.link,
                                      target: "_blank",
                                      rel: "noopener",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.debrief.link_caption ??
                                            _vm.debrief.link
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-4 trivia-debrief-button-container",
                      },
                      [
                        _c("div", { staticClass: "trivia-debrief-button" }, [
                          _c(
                            "button",
                            {
                              ref: "continueBtn",
                              staticClass: "btn primary-btn",
                              on: { click: _vm.handleContinue },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("CONTINUE")) +
                                  " →\n                    "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        _vm.questionComponent,
        {
          tag: "component",
          attrs: {
            question: _vm.question,
            "question-answered": _vm.questionAnswered,
            correct: _vm.correctAnswer,
            multiple: _vm.question.type === "multiple_choice",
          },
          on: {
            answer: _vm.submitAnswer,
            lightbox: function ($event) {
              _vm.lightboxSrc = $event
            },
          },
        },
        [
          _c("div", { staticClass: "trivia-question" }, [
            _vm.question.image_path
              ? _c("div", { staticClass: "trivia-image-section" }, [
                  _c("img", {
                    staticClass: "img img-circle",
                    attrs: { src: _vm.question.image_path },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "image-caption",
                    domProps: { innerHTML: _vm._s(_vm.question.image_caption) },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "trivia-question-text",
              domProps: { innerHTML: _vm._s(_vm.question.question) },
              on: { click: _vm.handleBodyImageClick },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "trivia-heading" }, [
            _c("h2", [_vm._v(_vm._s(_vm.question.heading))]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.lightboxSrc
        ? _c(
            "div",
            {
              staticClass: "trivia-lightbox",
              on: {
                click: function ($event) {
                  _vm.lightboxSrc = null
                },
              },
            },
            [
              _c("img", {
                attrs: { src: _vm.lightboxSrc },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }